import { render, staticRenderFns } from "./BackupManage.vue?vue&type=template&id=f8eab82c&scoped=true&"
import script from "./BackupManage.vue?vue&type=script&lang=js&"
export * from "./BackupManage.vue?vue&type=script&lang=js&"
import style0 from "./BackupManage.vue?vue&type=style&index=0&id=f8eab82c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8eab82c",
  null
  
)

export default component.exports